<template>
  <div class="patentA contentBack">
    <div class="contentBack4">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>专利管理 </el-breadcrumb-item>
        <el-breadcrumb-item class="breadSelected">专利分析 </el-breadcrumb-item>
      </el-breadcrumb>
      <div id="pdfDom">
        <!-- 1.筛选 -->
        <div class="analy">
          <!-- 选择地区 -->
          <div class="analySelect">
            <i
              class="el-icon-map-location"
              style="font-size: 17px; color: #000"
            ></i>
            <el-select v-model="region" @change="changeRegion">
              <el-option value="全部区域">全部区域</el-option>
              <el-option
                v-for="item in optionsRegion"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 选择时间 -->
          <div class="timeblock">
            <i class="iconfont">&#xe6c2;</i>
            <el-cascader
              v-model="timevalue"
              :options="optionsTime"
              @change="handleTimeChange"
            >
            </el-cascader>
          </div>
          <div class="data-tips">注：数据统计维度为专利地址在乐山</div>
          <div class="downreport" @click="btnClick">
            <i class="iconfont">&#xe6d0;</i> 下载报告
          </div>
        </div>
        <!-- <div>{{this.region}}</div> -->
        <!-- 筛选结束 -->
        <!-- 2.统计 -->

        <div class="stats">
          <!-- <div>
          申请（已公开）专利量：<span>{{ dataSummary.apTotal }}</span> 件
        </div> -->

          <div class="trademark-one">
            <div class="trademark-img"><i class="iconfont">&#xe6c8;</i></div>
            <div class="trademark-text">
              <div class="trandemark-num">
                <div class="trandemark-tit">申请（已公开）专利量</div>
                <span>{{ dataSummary.apTotal || 0 }}</span>
                <span class="trandemark-num1">件</span>
              </div>
            </div>
          </div>

          <div class="trademark-one">
            <div class="trademark-img"><i class="iconfont">&#xe6cf;</i></div>
            <div class="trademark-text">
              <div class="trandemark-num">
                <div class="trandemark-tit">授权专利量</div>
                <span>{{ dataSummary.auTotal || 0 }}</span>
                <span class="trandemark-num1">件</span>
              </div>
            </div>
          </div>

          <div class="trademark-one">
            <div class="trademark-img"><i class="iconfont">&#xe6d2;</i></div>
            <div class="trademark-text">
              <div class="trandemark-num">
                <div class="trandemark-tit">有效发明量(累计)</div>
                <span>{{ dataSummary.inventionTotal || 0 }}</span>
                <span class="trandemark-num1">件</span>
              </div>
            </div>
          </div>
          <div class="trademark-one">
            <div class="trademark-img"><i class="iconfont">&#xe6d3;</i></div>
            <div class="trademark-text">
              <div class="trandemark-num">
                <div class="trandemark-tit">PCT专利量</div>
                <span>{{ dataSummary.pctTotal || 0 }}</span>
                <span class="trandemark-num1">件</span>
              </div>
            </div>
          </div>
          <div class="trademark-one">
            <div class="trademark-img"><i class="iconfont">&#xe6d3;</i></div>
            <div class="trademark-text">
              <div class="trandemark-num">
                <div class="trandemark-tit">万人发明专利拥有量(累计)</div>
                <span>{{ dataSummary.avgNum || 0 }}</span>
                <span class="trandemark-num1">件</span>
              </div>
            </div>
          </div>
          <div class="trademark-one">
            <div class="trademark-img"><i class="iconfont">&#xe6d3; </i></div>
            <div class="trademark-text">
              <div class="trandemark-num">
                <div class="trandemark-tit">万人价值较高发明专利拥有量(累计)</div>
                <span>{{ dataSummary.highAvgNum || 0 }} </span>
                <span class="trandemark-num1">件</span>
              </div>
            </div>
          </div>
           <div class="trademark-one">
            <div class="trademark-img"><i class="iconfont">&#xe6d3; </i></div>
            <div class="trademark-text">
              <div class="trandemark-num">
                <div class="trandemark-tit">专利质押登记量</div>
                <span>{{ dataSummary.zyTotal || 0 }} </span>
                <span class="trandemark-num1">件</span>
              </div>
            </div>
          </div>
           <div class="trademark-one">
            <div class="trademark-img"><i class="iconfont">&#xe6d3; </i></div>
            <div class="trademark-text">
              <div class="trandemark-num">
                <div class="trandemark-tit">专利核准转让量</div>
                <span>{{ dataSummary.zrTotal || 0 }} </span>
                <span class="trandemark-num1">件</span>
              </div>
            </div>
          </div>
           <div class="trademark-one">
            <div class="trademark-img"><i class="iconfont">&#xe6d3; </i></div>
            <div class="trademark-text">
              <div class="trandemark-num">
                <div class="trandemark-tit">专利许可备案量</div>
                <span>{{ dataSummary.xkTotal || 0 }} </span>
                <span class="trandemark-num1">件</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 统计结束 -->
        <div
          style="
            height: 11px;
            width: 100%;
            background: #f2f2f2;
            margin-top: 20px;
          "
        ></div>
        <!-- 3.国内专利分析 -->
        <div>
          <div class="inside">
            <div class="inside-title">
              <div></div>
              国内专利分析
            </div>
          </div>
          <!-- <div class="analyTitle">国内专利分析</div> -->
          <!-- <div class="zl1" style="margin-top: 22px; margin-bottom: 22px"> -->
          <!-- 3-1.国内专利趋势 -->
          <div id="gnzlqs" class="zl2">
            <div class="checkEchart">
              <div
                @click="switchEchart(1)"
                :class="{ checked: echartsType1 == 1 }"
              >
                <i class="iconfont">&#xe6df;</i>
                <p>柱状图</p>
              </div>
              <div
                @click="switchEchart(2)"
                :class="{ checked: echartsType1 == 2 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle">国内专利趋势</p>
            <div v-show="havedata1">
              <!-- 柱状图 -->
              <div
                v-show="echartsType1 == 1"
                class="echartsBox1 domesticzltrend"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType1 == 2">
                <el-table
                  :data="trendApListzl"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="时间"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num"
                    label="专利申请量"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="num2"
                    label="专利授权量"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata1" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 3-2.专利类型构成 -->
          <div id="zllxgc" class="zl2">
            <div class="checkEchart">
              <div
                @click="switchEchart(3)"
                :class="{ checked: echartsType2 == 3 }"
              >
                <i class="iconfont">&#xe6e1;</i>
                <p>饼状图</p>
              </div>
              <div
                @click="switchEchart(4)"
                :class="{ checked: echartsType2 == 4 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle">专利类型构成</p>
            <div class="sqSwitch">
              <button @click="applybtn(1)" :class="{ numbtn: numType1 == 1 }">
                申请量
              </button>
              <button @click="agreebtn(2)" :class="{ numbtn: numType1 == 2 }">
                授权量
              </button>
            </div>
            <!-- 柱状图 -->
            <div
              v-show="echartsType2 == 3 && numType1 == 1 && havedata2"
              class="echartsBox1 zlType1"
            ></div>
            <div
              v-show="echartsType2 == 3 && numType1 == 1 && !havedata2"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType2 == 3 && numType1 == 2 && havedata3"
              class="echartsBox1 zlType2"
            ></div>
            <div
              v-show="echartsType2 == 3 && numType1 == 2 && !havedata3"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <!-- 数据视图 -->
            <div v-show="echartsType2 == 4 && numType1 == 1 && havedata2">
              <el-table
                :data="apTyCountzl"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="专利类型"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="专利申请量"
                >
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType2 == 4 && numType1 == 1 && !havedata2"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType2 == 4 && numType1 == 2 && havedata3">
              <el-table
                :data="apTyAuthCountzl"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="专利类型"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="专利授权量"
                >
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType2 == 4 && numType1 == 2 && !havedata3"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- </div> -->
          <!-- 3-3.申请人构成及趋势 -->
          <div id="sqrgc" class="zl2">
            <div class="checkEchart">
              <div
                @click="switchEchart(5)"
                :class="{ checked: echartsType3 == 5 }"
              >
                <i class="iconfont">&#xe6e0;</i>
                <p>面积图</p>
              </div>
              <div
                @click="switchEchart(6)"
                :class="{ checked: echartsType3 == 6 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">申请人构成及趋势</p>
            <div class="sqSwitch">
              <button @click="applybtn(3)" :class="{ numbtn: numType2 == 3 }">
                申请量
              </button>
              <button @click="agreebtn(4)" :class="{ numbtn: numType2 == 4 }">
                授权量
              </button>
            </div>
            <!--面积图  -->
            <div
              v-show="echartsType3 == 5 && numType2 == 3 && havedata4"
              class="echartsBox1 applyMakeup1"
            ></div>
            <div
              v-show="echartsType3 == 5 && numType2 == 3 && !havedata4"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType3 == 5 && numType2 == 4 && havedata5"
              class="echartsBox1 applyMakeup2"
            ></div>
            <div
              v-show="echartsType3 == 5 && numType2 == 4 && !havedata5"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <!-- 数据视图 -->
            <div v-show="echartsType3 == 6 && numType2 == 3">
              <table class="myTable">
                <tr>
                  <th>申请人类型</th>
                  <th v-for="(item, index) of timeRange" :key="index">
                    {{ item }}
                  </th>
                </tr>
                <tr>
                  <td>工矿企业</td>
                  <td
                    v-for="(gk, gkindex) of this.$store.state.gkcompany"
                    :key="gkindex"
                  >
                    {{ gk }}
                  </td>
                </tr>
                <tr>
                  <td>科研院所</td>
                  <td
                    v-for="(ky, kyindex) of this.$store.state.sciencedw"
                    :key="kyindex"
                  >
                    {{ ky }}
                  </td>
                </tr>
                <tr>
                  <td>大专院校</td>
                  <td
                    v-for="(dz, dzindex) of this.$store.state.dzschool"
                    :key="dzindex"
                  >
                    {{ dz }}
                  </td>
                </tr>
                <tr>
                  <td>机关团体</td>
                  <td
                    v-for="(jg, jgindex) of this.$store.state.jggroup"
                    :key="jgindex"
                  >
                    {{ jg }}
                  </td>
                </tr>
                <tr>
                  <td>个人</td>
                  <td
                    v-for="(man, manindex) of this.$store.state.single"
                    :key="manindex"
                  >
                    {{ man }}
                  </td>
                </tr>
              </table>
            </div>
            <div
              v-show="echartsType3 == 6 && numType2 == 3 && !havedata4"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType3 == 6 && numType2 == 4 && havedata5">
              <table class="myTable">
                <tr>
                  <th>申请人类型</th>
                  <th v-for="(item, index) of timeRange" :key="index">
                    {{ item }}
                  </th>
                </tr>
                <tr>
                  <td>工矿企业</td>
                  <td
                    v-for="(gk, gkindex) of this.$store.state.gkcompanyAuth"
                    :key="gkindex"
                  >
                    {{ gk }}
                  </td>
                </tr>
                <tr>
                  <td>科研院所</td>
                  <td
                    v-for="(ky, kyindex) of this.$store.state.sciencedwAuth"
                    :key="kyindex"
                  >
                    {{ ky }}
                  </td>
                </tr>
                <tr>
                  <td>大专院校</td>
                  <td
                    v-for="(dz, dzindex) of this.$store.state.dzschoolAuth"
                    :key="dzindex"
                  >
                    {{ dz }}
                  </td>
                </tr>
                <tr>
                  <td>机关团体</td>
                  <td
                    v-for="(jg, jgindex) of this.$store.state.jggroupAuth"
                    :key="jgindex"
                  >
                    {{ jg }}
                  </td>
                </tr>
                <tr>
                  <td>个人</td>
                  <td
                    v-for="(man, manindex) of this.$store.state.singleAuth"
                    :key="manindex"
                  >
                    {{ man }}
                  </td>
                </tr>
              </table>
            </div>
            <div
              v-show="echartsType3 == 6 && numType2 == 4 && !havedata5"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 3-4.IPC技术分类Top10 -->
          <div id="ipcjstop10" class="zl2">
            <div class="checkEchart">
              <div
                @click="switchEchart(7)"
                :class="{ checked: echartsType4 == 7 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(8)"
                :class="{ checked: echartsType4 == 8 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">IPC技术分类Top10</p>
            <div class="sqSwitch">
              <button @click="applybtn(5)" :class="{ numbtn: numType3 == 5 }">
                申请量
              </button>
              <button @click="agreebtn(6)" :class="{ numbtn: numType3 == 6 }">
                授权量
              </button>
            </div>
            <!-- 条形图 -->
            <div
              v-show="echartsType4 == 7 && numType3 == 5 && havedata6"
              class="echartsBox1 ipcTecnicType1"
            ></div>
            <div
              v-show="echartsType4 == 7 && numType3 == 5 && !havedata6"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType4 == 7 && numType3 == 6 && havedata7"
              class="echartsBox1 ipcTecnicType2"
            ></div>
            <div
              v-show="echartsType4 == 7 && numType3 == 6 && !havedata7"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <!-- 数据视图 -->
            <div v-show="echartsType4 == 8 && numType3 == 5 && havedata6">
              <el-table
                :data="ipcCount"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="IPC分类">
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="专利申请量"
                >
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType4 == 8 && numType3 == 5 && !havedata6"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType4 == 8 && numType3 == 6 && havedata7">
              <el-table
                :data="ipcAuthCount"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column :resizable="false" prop="name" label="IPC分类">
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="专利授权量"
                >
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType4 == 8 && numType3 == 6 && !havedata7"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 3-5.有效专利权利人分布 -->
          <div id="yxfmwcfb" class="zl2 zl2new">
            <div class="checkEchart">
              <div
                @click="switchEchart(9)"
                :class="{ checked: echartsType5 == 9 }"
              >
                <i class="iconfont">&#xe6e0;</i>
                <p>饼状图</p>
              </div>
              <div
                @click="switchEchart(10)"
                :class="{ checked: echartsType5 == 10 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
        <div class="echarts-title">
              <p class="biaoTitle2">有效专利权利人分布</p>
            <div class="apValidzl">发明专利</div>
        </div>
           
            <!-- 面积图 -->
            <div
              v-show="echartsType5 == 9  && havedata8"
              class="echartsBox1 rightIntener1"
            ></div>
            <div
              v-show="echartsType5 == 9  && !havedata8"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
               <!-- 数据视图 -->
            <div v-show="echartsType5 == 10 && havedata8" class="apValidata">
              <el-table
                :data="apValidzl"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="权利人类型"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="权利人数量"
                >
                </el-table-column>
              </el-table>
            </div>
            <!-- 数据视图,外观设计 -->
         
       <div class="checkEchart">
              <div
                @click="switchEchart(29)"
                :class="{ checked: echartsType15 == 29 }"
              >
                <i class="iconfont">&#xe6e0;</i>
                <p>饼状图</p>
              </div>
              <div
                @click="switchEchart(30)"
                :class="{ checked: echartsType15 == 30 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
             <div class="echarts-title">
            <p class="biaoTitle2">有效专利权利人分布</p>
            <div class="apValidzl">实用新型</div>
            </div>
            <!-- 面积图 -->
            <div
              v-show="echartsType15 == 29  && havedata25"
              class="echartsBox1 rightIntener2"
            ></div>
            <div
              v-show="echartsType15 == 29  && !havedata25"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            
               <!-- 数据视图 -->
            <div v-show="echartsType15 == 30 && havedata25" class="apValidata">
              <el-table
                :data="utilityValidInvzl"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="权利人类型"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="权利人数量"
                >
                </el-table-column>
              </el-table>
            </div>
            <!-- 实用新型 -->
         
              <div class="checkEchart">
              <div
                @click="switchEchart(31)"
                :class="{ checked: echartsType16 == 31 }"
              >
                <i class="iconfont">&#xe6e0;</i>
                <p>饼状图</p>
              </div>
              <div
                @click="switchEchart(32)"
                :class="{ checked: echartsType16 == 32 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
              <div class="echarts-title">
            <p class="biaoTitle2">有效专利权利人分布</p>
           <div class="apValidzl">外观设计</div>
           </div>
            <!-- 面积图 -->
            <div
              v-show="echartsType16 == 31  && havedata26"
              class="echartsBox1 rightIntener3"
            ></div>
            <div
              v-show="echartsType16 == 32  && !havedata26"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            
       
               <!-- 数据视图 -->
            <div v-show="echartsType16 == 32  && havedata26" class="apValidata">
              <el-table
                :data="designValidInvzl"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="权利人类型"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="权利人数量"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>

              <!-- 3-6.专利质押登记量趋势 -->
          <div id="zlzydjqs" class="zl2">
               <div class="checkEchart">
              <div
                @click="switchEchart(23)"
                :class="{ checked: echartsType12 == 23 }"
              >
                <i class="iconfont">&#xe6e0;</i>
                <p>面积图</p>
              </div>
              <div
                @click="switchEchart(24)"
                :class="{ checked: echartsType12 == 24 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">专利质押登记量趋势</p>
        
            <div v-show="havedata22">
            <!-- 面积图 -->
            <div v-show="echartsType12 == 23" class="echartsBox1 patentdj"></div>
            <!-- 数据视图 -->
            <div v-show="echartsType12 == 24">
              <el-table
                :data="zyTrend"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column :resizable="false" prop="time" label="时间"> </el-table-column>
                <el-table-column :resizable="false" prop="num" label="专利质押登记量"> </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-show="!havedata22" class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>

          
          
          </div>
              <!-- 3-6.专利核准转让量趋势 -->
          <div id="zlhzzr" class="zl2">
               <div class="checkEchart">
              <div
                @click="switchEchart(25)"
                :class="{ checked: echartsType13 == 25 }"
              >
                <i class="iconfont">&#xe6e0;</i>
                <p>面积图</p>
              </div>
              <div
                @click="switchEchart(26)"
                :class="{ checked: echartsType13 == 26 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">专利核准转让量趋势</p>
        
            <div v-show="havedata23">
            <!-- 面积图 -->
            <div v-show="echartsType13 == 25" class="echartsBox1 patentzhuanrang"></div>
            <!-- 数据视图 -->
            <div v-show="echartsType13 == 26">
              <el-table
                :data="zrTrend"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column :resizable="false" prop="time" label="时间"> </el-table-column>
                <el-table-column :resizable="false" prop="num" label="专利核准转让量"> </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-show="!havedata23" class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>

          
          
          </div>
              <!-- 3-6.专利许可备案量趋势 -->
          <div id="zlxkbal" class="zl2">
               <div class="checkEchart">
              <div
                @click="switchEchart(27)"
                :class="{ checked: echartsType14 == 27 }"
              >
                <i class="iconfont">&#xe6e0;</i>
                <p>面积图</p>
              </div>
              <div
                @click="switchEchart(28)"
                :class="{ checked: echartsType14 == 28 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">专利许可备案量趋势</p>
        
            <div v-show="havedata24">
            <!-- 面积图 -->
            <div v-show="echartsType14 == 27" class="echartsBox1 patentxuke"></div>
            <!-- 数据视图 -->
            <div v-show="echartsType14 == 28">
              <el-table
                :data="xkTrend"
                border
                stripe
                style="width: 90%; margin: 4% auto 0"
              >
                <el-table-column :resizable="false" prop="time" label="时间"> </el-table-column>
                <el-table-column :resizable="false" prop="num" label="专利许可备案量"> </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-show="!havedata24" class="blankimg">
            <img src="../assets/imgs/blankIMG.png" />
            <p>暂无数据</p>
          </div>

          
          
          </div>

          
          <!-- 3-6.国内专利分析榜单 -->
          <div id="gnzlfxbd" class="zl2">
            <div class="checkEchart">
              <div
                @click="switchEchart(11)"
                :class="{ checked: echartsType6 == 11 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(12)"
                :class="{ checked: echartsType6 == 12 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">国内专利分析榜单</p>
            <div class="sqSwitch">
              <button @click="applybtn(9)" :class="{ numbtn: numType5 == 9 }">
                申请量
              </button>
              <button @click="agreebtn(10)" :class="{ numbtn: numType5 == 10 }">
                授权量
              </button>
              <button @click="yxfmbtn(11)" :class="{ numbtn: numType5 == 11 }">
                有效发明量(累计)
              </button>
              <button @click="wxzlbtn(12)" :class="{ numbtn: numType5 == 12 }">
                无效专利量
              </button>
            </div>
            <!-- 条形图 -->
            <div
              v-show="echartsType6 == 11 && numType5 == 9 && havedata10"
              class="echartsBox1 domesticzltop1"
            ></div>
            <div
              v-show="echartsType6 == 11 && numType5 == 9 && !havedata10"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType6 == 11 && numType5 == 10 && havedata11"
              class="echartsBox1 domesticzltop2"
            ></div>
            <div
              v-show="echartsType6 == 11 && numType5 == 10 && !havedata11"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType6 == 11 && numType5 == 11 && havedata12"
              class="echartsBox1 domesticzltop3"
            ></div>
            <div
              v-show="echartsType6 == 11 && numType5 == 11 && !havedata12"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType6 == 11 && numType5 == 12 && havedata13"
              class="echartsBox1 domesticzltop4"
            ></div>
            <div
              v-show="echartsType6 == 11 && numType5 == 12 && !havedata13"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <!-- 数据视图 -->
            <div v-show="echartsType6 == 12 && numType5 == 9 && havedata10">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(101)"
                  :disabled="appTop10.length === appTop50.length"
                  >更多</el-button
                >
                <!-- <el-button>更多</el-button> -->
              </div>
              <el-table :data="appTop10" border stripe class="el-tableclass">
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="企业名称"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="专利申请量"
                >
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType6 == 12 && numType5 == 9 && !havedata10"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType6 == 12 && numType5 == 10 && havedata11">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(102)"
                  :disabled="authTop10.length === authTop50.length"
                  >更多</el-button
                >
                <!-- <el-button>更多</el-button> -->
              </div>
              <el-table :data="authTop10" border stripe class="el-tableclass">
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="企业名称"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="专利授权量"
                >
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType6 == 12 && numType5 == 10 && !havedata11"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType6 == 12 && numType5 == 11 && havedata12">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(103)"
                  :disabled="validTop10.length === validTop50.length"
                  >更多</el-button
                >
                <!-- <el-button>更多</el-button> -->
              </div>
              <el-table :data="validTop10" border stripe class="el-tableclass">
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="企业名称"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="有效发明量(累计)"
                >
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType6 == 12 && numType5 == 11 && !havedata12"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType6 == 12 && numType5 == 12 && havedata13">
              <div class="titleBox">
                <el-button
                  @click="seeMore50(104)"
                  :disabled="notValidTop10.length === notValidTop50.length"
                  >更多</el-button
                >
                <!-- <el-button>更多</el-button> -->
              </div>
              <el-table
                :data="notValidTop10"
                border
                stripe
                class="el-tableclass"
              >
                <el-table-column
                  :resizable="false"
                  type="index"
                  label="排序"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="name"
                  label="企业名称"
                >
                </el-table-column>
                <el-table-column
                  :resizable="false"
                  prop="num"
                  label="无效专利量"
                >
                </el-table-column>
              </el-table>
            </div>
            <div
              v-show="echartsType6 == 12 && numType5 == 12 && !havedata13"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        </div>
        <div
          style="
            height: 20px;
            width: 100%;
            background: #f2f2f2;
            margin-top: 20px;
          "
        ></div>
        <!-- 4.PCT公开专利分析 -->
        <div>
          <div class="inside">
            <div class="inside-title">
              <div></div>
              PCT公开专利分析
            </div>
          </div>
          <!-- <div class="analyTitle">PCT公开专利分析</div> -->
          <!-- <div -->

          <!-- 4-1.PCT专利趋势 -->
          <div id="pctzlqs" class="zl2">
            <div class="checkEchart">
              <div
                @click="switchEchart(13)"
                :class="{ checked: echartsType7 == 13 }"
              >
                <i class="iconfont">&#xe6e0;</i>
                <p>面积图</p>
              </div>
              <div
                @click="switchEchart(14)"
                :class="{ checked: echartsType7 == 14 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle">PCT专利趋势</p>
            <div v-show="havedata14">
              <!-- 面积图 -->
              <div
                v-show="echartsType7 == 13"
                class="echartsBox1 pctzltrend"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType7 == 14">
                <el-table
                  :data="pctTrendCount"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column :resizable="false" prop="name" label="时间">
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="公开量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata4" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- 4-2.IPC分类Top10 -->
          <div id="ipctop10" class="zl2">
            <div class="checkEchart">
              <div
                @click="switchEchart(15)"
                :class="{ checked: echartsType8 == 15 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(16)"
                :class="{ checked: echartsType8 == 16 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle">IPC分类Top10</p>
            <div v-show="havedata15">
              <!-- 条形图 -->
              <div
                v-show="echartsType8 == 15"
                class="echartsBox3 ipcttype"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType8 == 16">
                <el-table
                  :data="pctIpcTop10"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="IPC分类"
                  >
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="申请量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata15" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
          <!-- </div> -->
          <!-- 4-3.PCT公开量Top10 -->
          <div id="pctzlqs" class="zl2" style="margin-bottom: 30px">
            <div class="checkEchart">
              <div
                @click="switchEchart(17)"
                :class="{ checked: echartsType9 == 17 }"
              >
                <i class="iconfont">&#xe6de;</i>
                <p>条形图</p>
              </div>
              <div
                @click="switchEchart(18)"
                :class="{ checked: echartsType9 == 18 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">PCT公开量Top10</p>
            <div v-show="havedata16">
              <!-- 条形图 -->
              <div
                v-show="echartsType9 == 17"
                class="echartsBox1 pctPublictop10"
              ></div>
              <!-- 数据视图 -->
              <div v-show="echartsType9 == 18">
                <div class="titleBox">
                  <el-button
                    @click="seeMore50(105)"
                    :disabled="pctTop10Count.length === pctTop50Count.length"
                    >更多</el-button
                  >
                </div>
                <el-table
                  :data="pctTop10Count"
                  border
                  stripe
                  style="width: 90%; margin: 0 auto"
                >
                  <el-table-column
                    :resizable="false"
                    type="index"
                    label="排序"
                    width="60"
                  >
                  </el-table-column>
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="企业名称"
                  >
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="公开量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata16" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        </div>
        <div style="height: 20px; width: 100%; background: #f2f2f2"></div>
        <!--5.专利状态分析  -->
        <div>
          <div class="inside">
            <div class="inside-title">
              <div></div>
              专利状态分析
            </div>
          </div>
          <!-- <div class="analyTitle">专利状态分析</div> -->
          <div id="zlztfx" class="zl2" style="margin-bottom: 20px">
            <div class="checkEchart">
              <div
                @click="switchEchart(19)"
                :class="{ checked: echartsType10 == 19 }"
              >
                <i class="iconfont">&#xe6e1;</i>
                <p>饼状图</p>
              </div>
              <div
                @click="switchEchart(20)"
                :class="{ checked: echartsType10 == 20 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">专利状态分析</p>
            <div v-show="havedata17">
              <!--饼状图  -->
              <div
                v-show="echartsType10 == 19"
                class="echartsBox1 zlstatus"
              ></div>
              <!--数据视图  -->
              <div v-show="echartsType10 == 20">
                <el-table
                  :data="ptLawCount"
                  border
                  stripe
                  style="width: 90%; margin: 4% auto 0"
                >
                  <el-table-column
                    :resizable="false"
                    prop="name"
                    label="法律状态"
                  >
                  </el-table-column>
                  <el-table-column :resizable="false" prop="num" label="专利量">
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-show="!havedata17" class="blankimg">
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
          </div>
        </div>
        <div style="height: 20px; width: 100%; background: #f2f2f2"></div>
        <!--6.区域专利比较  -->
        <div>
          <div class="inside">
            <div class="inside-title">
              <div></div>
              区域专利比较
            </div>
          </div>
          <div id="qyzlbj" class="zl2" style="margin-bottom: 20px">
            <div class="checkEchart">
              <div
                @click="switchEchart(21)"
                :class="{ checked: echartsType11 == 21 }"
              >
                <i class="iconfont">&#xe6e0;</i>
                <p>面积图</p>
              </div>
              <div
                @click="switchEchart(22)"
                :class="{ checked: echartsType11 == 22 }"
              >
                <i class="iconfont">&#xe6af;</i>
                <p>数据视图</p>
              </div>
            </div>
            <p class="biaoTitle2">区域专利比较</p>
            <div class="sqSwitch">
              <button @click="applybtn(13)" :class="{ numbtn: numType6 == 13 }">
                申请量
              </button>
              <button @click="agreebtn(14)" :class="{ numbtn: numType6 == 14 }">
                授权量
              </button>
              <button @click="yxfmbtn(15)" :class="{ numbtn: numType6 == 15 }">
                PCT申请
              </button>
              <button @click="wxzlbtn(16)" :class="{ numbtn: numType6 == 16 }">
                有效专利量(累计)
              </button>
            </div>
            <!--面积图  -->
            <div
              v-show="echartsType11 == 21 && numType6 == 13 && havedata18"
              class="echartsBox1 regionzlDCompare1"
            ></div>
            <div
              v-show="echartsType11 == 21 && numType6 == 13 && !havedata18"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType11 == 21 && numType6 == 14 && havedata19"
              class="echartsBox1 regionzlDCompare2"
            ></div>
            <div
              v-show="echartsType11 == 21 && numType6 == 14 && !havedata19"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType11 == 21 && numType6 == 15 && havedata20"
              class="echartsBox1 regionzlDCompare3"
            ></div>
            <div
              v-show="echartsType11 == 21 && numType6 == 15 && !havedata20"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div
              v-show="echartsType11 == 21 && numType6 == 16 && havedata21"
              class="echartsBox1 regionzlDCompare4"
            ></div>
            <div
              v-show="echartsType11 == 21 && numType6 == 16 && !havedata21"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <!--数据视图  -->
            <div v-show="echartsType11 == 22 && numType6 == 13 && havedata18">
              <table class="myTable myTable2" style="width: 90%">
                <tr>
                  <th>专利类型</th>
                  <th
                    v-for="(item, index) of this.$store.state.ApplyXzl"
                    :key="index"
                  >
                    {{ item }}
                  </th>
                </tr>
                <tr>
                  <td>发明</td>
                  <td
                    v-for="(gk, gkindex) of this.$store.state.ApplyFM"
                    :key="gkindex"
                  >
                    {{ gk }}
                  </td>
                </tr>
                <tr>
                  <td>实用新型</td>
                  <td
                    v-for="(ky, kyindex) of this.$store.state.ApplySY"
                    :key="kyindex"
                  >
                    {{ ky }}
                  </td>
                </tr>
                <tr>
                  <td>外观设计</td>
                  <td
                    v-for="(dz, dzindex) of this.$store.state.ApplyWG"
                    :key="dzindex"
                  >
                    {{ dz }}
                  </td>
                </tr>
              </table>
            </div>
            <div
              v-show="echartsType11 == 22 && numType6 == 13 && !havedata18"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType11 == 22 && numType6 == 14 && havedata19">
              <table class="myTable myTable2">
                <tr>
                  <th>专利类型</th>
                  <th
                    v-for="(item, index) of this.$store.state.AuthXzl"
                    :key="index"
                  >
                    {{ item }}
                  </th>
                </tr>
                <tr>
                  <td>发明</td>
                  <td
                    v-for="(gk, gkindex) of this.$store.state.AuthFM"
                    :key="gkindex"
                  >
                    {{ gk }}
                  </td>
                </tr>
                <tr>
                  <td>实用新型</td>
                  <td
                    v-for="(ky, kyindex) of this.$store.state.AuthSY"
                    :key="kyindex"
                  >
                    {{ ky }}
                  </td>
                </tr>
                <tr>
                  <td>外观设计</td>
                  <td
                    v-for="(dz, dzindex) of this.$store.state.AuthWG"
                    :key="dzindex"
                  >
                    {{ dz }}
                  </td>
                </tr>
              </table>
            </div>
            <div
              v-show="echartsType11 == 22 && numType6 == 14 && !havedata19"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType11 == 22 && numType6 == 15 && havedata20">
              <table class="myTable myTable2">
                <tr>
                  <th>专利类型</th>
                  <th
                    v-for="(item, index) of this.$store.state.pctXzl"
                    :key="index"
                  >
                    {{ item }}
                  </th>
                </tr>
                <tr>
                  <td>发明</td>
                  <td
                    v-for="(gk, gkindex) of this.$store.state.pctFM"
                    :key="gkindex"
                  >
                    {{ gk }}
                  </td>
                </tr>
                <tr>
                  <td>实用新型</td>
                  <td
                    v-for="(ky, kyindex) of this.$store.state.pctSY"
                    :key="kyindex"
                  >
                    {{ ky }}
                  </td>
                </tr>
              </table>
            </div>
            <div
              v-show="echartsType11 == 22 && numType6 == 15 && !havedata20"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div v-show="echartsType11 == 22 && numType6 == 16 && havedata21">
              <table class="myTable myTable2">
                <tr>
                  <th>专利类型</th>
                  <th
                    v-for="(item, index) of this.$store.state.wxXzl"
                    :key="index"
                  >
                    {{ item }}
                  </th>
                </tr>
                <tr>
                  <td>发明</td>
                  <td
                    v-for="(gk, gkindex) of this.$store.state.wxFM"
                    :key="gkindex"
                  >
                    {{ gk }}
                  </td>
                </tr>
                <tr>
                  <td>实用新型</td>
                  <td
                    v-for="(ky, kyindex) of this.$store.state.wxSY"
                    :key="kyindex"
                  >
                    {{ ky }}
                  </td>
                </tr>
                <tr>
                  <td>外观设计</td>
                  <td
                    v-for="(dz, dzindex) of this.$store.state.wxWG"
                    :key="dzindex"
                  >
                    {{ dz }}
                  </td>
                </tr>
              </table>
            </div>
            <div
              v-show="echartsType11 == 22 && numType6 == 16 && !havedata21"
              class="blankimg"
            >
              <img src="../assets/imgs/blankIMG.png" />
              <p>暂无数据</p>
            </div>
            <div class="other-tips">
                  注：“其他”表示暂时无法识别商标/专利所属区
                </div>
          </div>
        </div>
        <div style="height: 30px; width: 100%; background: #f2f2f2"></div>
      </div>
    </div>
    <!-- ****右边定位box -->
    <div
      class="positionBox"
      :class="{ cotrolshow: ispositionBox, cotrolnotshow: !ispositionBox }"
    >
      <div
        class="positionBoxCotrol"
        @click="positionBoxShow"
        :class="{ turnLeft11: ispositionBox }"
      >
        <i
          :class="{ arrowrotate: ispositionBox, norotate: !ispositionBox }"
          class="el-icon-arrow-right"
        ></i>
        <i
          :class="{ arrowrotate: ispositionBox, norotate: !ispositionBox }"
          class="el-icon-arrow-right"
        ></i>
      </div>
      <div style="position: relative">
        <p>国内专利分析</p>
        <a :class="{ visited: avisit == 1 }" @click="turnAstyle(1, '#gnzlqs')"
          >国内专利趋势</a
        >
        <a :class="{ visited: avisit == 2 }" @click="turnAstyle(2, '#zllxgc')"
          >专利类型构成</a
        >
        <a :class="{ visited: avisit == 3 }" @click="turnAstyle(3, '#sqrgc')"
          >申请人构成及趋势</a
        >
        <a
          :class="{ visited: avisit == 4 }"
          @click="turnAstyle(4, '#ipcjstop10')"
          >IPC分类Top10</a
        >
        <a :class="{ visited: avisit == 5 }" @click="turnAstyle(5, '#yxfmwcfb')"
          >有效专利权利人分布</a
        >
         <a :class="{ visited: avisit == 12 }" @click="turnAstyle(12, '#zlzydjqs')"
          >专利质押登记量趋势</a
        >
         <a :class="{ visited: avisit == 13 }" @click="turnAstyle(13, '#zlhzzr')"
          >专利核准转让量趋势</a
        >
         <a :class="{ visited: avisit == 14 }" @click="turnAstyle(14, '#zlxkbal')"
          >专利许可备案量趋势</a
        >
        <a
          :class="{ visited: avisit == 6 }"
          @click="turnAstyle(6, '#gnzlfxbd')"
          >国内专利分析榜单</a
        >
        <p>PCT公开专利分析</p>
        <a :class="{ visited: avisit == 7 }" @click="turnAstyle(7, '#pctzlqs')"
          >PCT专利趋势</a
        >
        <a :class="{ visited: avisit == 8 }" @click="turnAstyle(8, '#ipctop10')"
          >IPC分类Top10</a
        >
        <a :class="{ visited: avisit == 9 }" @click="turnAstyle(9, '#pctzlqs')"
          >PCT公开专利分析榜单</a
        >
        <p>
          <a
            :class="{ visited: avisit == 10 }"
            @click="turnAstyle(10, '#zlztfx')"
            style="margin-left: 0"
            >专利状态分析</a
          >
        </p>
        <p>
          <a
            :class="{ visited: avisit == 11 }"
            @click="turnAstyle(11, '#qyzlbj')"
            style="margin-left: 0"
            >区域专利比较</a
          >
        </p>
      </div>
    </div>
    <!-- ****************** -->
    <!-- *****更多 弹框 -->
    <div v-if="seeMore" class="popBoxMask"></div>
    <div v-if="seeMore" class="popBox">
      <div class="boxHeader">
        {{ label50 }}排名
        <i class="el-icon-close" @click="closeMore"> </i>
      </div>
      <div class="boxContent">
        <div class="titleBox" style="width: 100%; margin-top: 0">
          <span
            style="
              font-size: 18px;
              color: #000;
              text-align: left;
              margin-left: 28px;
              line-height: 50px;
              font-weight: bold;
            "
            >{{ label50 }}Top50</span
          >
          <el-button @click="daochu(label50)">导出Excel</el-button>
        </div>
        <el-table :data="tableData50" border style="width: 100%">
          <el-table-column
            :resizable="false"
            type="index"
            label="序号"
            width="60"
          >
          </el-table-column>
          <el-table-column :resizable="false" prop="name" label="企业名称">
          </el-table-column>
          <el-table-column :resizable="false" prop="num" :label="label50">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- ************* -->
  </div>
</template>
<script>
import Pantent from "../assets/js/diagrams/Pantent";
export default {
  data() {
    return {
      exportPDFtitle: "专利分析报告",
      arrowid: true,
      seeMore: false,
      region: "全部区域",
      timevalue: [],
      timevalueS: "",
      optionsTime: [
        {
          value: "2021",
          label: "2021年",
          children: [
            {
              value: "",
              label: "全部",
            },
            {
              value: "1",
              label: "第一季度",
            },
            {
              value: "2",
              label: "第二季度",
            },
            {
              value: "3",
              label: "第三季度",
            },
            {
              value: "4",
              label: "第四季度",
            },
          ],
        },
        {
          value: "2020",
          label: "2020年",
          children: [
            {
              value: "",
              label: "全部",
            },
            {
              value: "1",
              label: "第一季度",
            },
            {
              value: "2",
              label: "第二季度",
            },
            {
              value: "3",
              label: "第三季度",
            },
            {
              value: "4",
              label: "第四季度",
            },
          ],
        },
      ],
      optionsRegion: [],
      ispositionBox: false,
      avisit: 0,
      echartsType1: 1,
      echartsType2: 3,
      echartsType3: 5,
      echartsType4: 7,
      numType1: 1,
      numType2: 3,
      numType3: 5,
      numType4: 7,
      numType5: 9,
      numType6: 13,
      echartsType5: 9,
      echartsType6: 11,
      echartsType7: 13,
      echartsType8: 15,
      echartsType9: 17,
      echartsType10: 19,
      echartsType11: 21,
      echartsType12: 23,
      echartsType13: 25,
      echartsType14: 27,
      echartsType15: 29,
      echartsType16: 31,
      firstscroll1: true,
      firstscroll2: true,
      firstscroll3: true,
      firstscroll4: true,
      dataSummary: {},
      trendApListzl: [],
      apTyCountzl: [],
      apValidzl:[],
      utilityValidInvzl:[],
      designValidInvzl:[],
      apTyAuthCountzl: [],
      timeRange: [],
      ipcCount: [],
      ipcAuthCount: [],
      appTop10: [],
      appTop50: [],
      authTop10: [],
      authTop50: [],
      notValidTop10: [],
      notValidTop50: [],
      validTop10: [],
      validTop50: [],
      pctTrendCount: [],
      pctIpcTop10: [],
      pctTop10Count: [],
      pctTop50Count: [],
      ptLawCount: [],
      tableData50: [],
      label50: "",
      zrTrend:[],
      zyTrend:[],
      xkTrend:[],
      havedata1: true,
      havedata2: true,
      havedata3: true,
      havedata4: true,
      havedata5: true,
      havedata6: true,
      havedata7: true,
      havedata8: true,
      havedata9: true,
      havedata10: true,
      havedata11: true,
      havedata12: true,
      havedata13: true,
      havedata14: true,
      havedata15: true,
      havedata16: true,
      havedata17: true,
      havedata18: true,
      havedata19: true,
      havedata20: true,
      havedata21: true,
      // 专利
      havedata22: true,
      havedata23: true,
      havedata24: true,
      havedata25: true,
      havedata26: true,
    };
  },
  methods: {
    // 下载报告
    btnClick() {
      this.$nextTick(() => {
        this.getPdf();
      });
    },
    // 关闭更多弹框
    closeMore() {
      this.seeMore = false;
    },
    //   选择地区
    changeRegion(val) {
      this.region = val;
      this.firstscroll1 = true;
      this.firstscroll2 = true;
      this.firstscroll3 = true;
      this.firstscroll4 = true;
      this.zlAnalyCount();
      this.domasticzlDatas();
      this.scrollHandle();
    },
    // 选择时间
    handleTimeChange(value) {
      this.timevalueS = value.join("");
      this.firstscroll1 = true;
      this.zlAnalyCount();
      this.domasticzlDatas();
      this.firstscroll1 = true;
      this.firstscroll2 = true;
      this.firstscroll3 = true;
      this.firstscroll4 = true;
      this.scrollHandle();
    },
    //   控制定位box
    positionBoxShow() {
      this.ispositionBox = this.ispositionBox ? false : true;
      if (this.ispositionBox == false) {
        this.avisit = 0;
      }
    },
    turnAstyle(value, idName) {
      this.avisit = value;
      document.querySelector(idName).scrollIntoView(true);
    },
    // 切换图表图标
    switchEchart(val) {
      switch (val) {
        case 1:
          this.echartsType1 = 1;
          break;
        case 2:
          this.echartsType1 = 2;
          break;
        case 3:
          this.echartsType2 = 3;
          break;
        case 4:
          this.echartsType2 = 4;
          break;
        case 5:
          this.echartsType3 = 5;
          break;
        case 6:
          this.echartsType3 = 6;
          break;
        case 7:
          this.echartsType4 = 7;
          break;
        case 8:
          this.echartsType4 = 8;
          break;
        case 9:
          this.echartsType5 = 9;
          break;
        case 10:
          this.echartsType5 = 10;
          break;
        case 11:
          this.echartsType6 = 11;
          break;
        case 12:
          this.echartsType6 = 12;
          break;
        case 13:
          this.echartsType7 = 13;
          break;
        case 14:
          this.echartsType7 = 14;
          break;
        case 15:
          this.echartsType8 = 15;
          break;
        case 16:
          this.echartsType8 = 16;
          break;
        case 17:
          this.echartsType9 = 17;
          break;
        case 18:
          this.echartsType9 = 18;
          break;
        case 19:
          this.echartsType10 = 19;
          break;
        case 20:
          this.echartsType10 = 20;
          break;
        case 21:
          this.echartsType11 = 21;
          break;
           case 22:
          this.echartsType11 = 22;
          break;
        case 23:
          this.echartsType12 = 23;
          break;
           case 24:
          this.echartsType12 = 24;
          break;
           case 25:
          this.echartsType13 = 25;
          break;
           case 26:
          this.echartsType13 = 26;
          break;
           case 27:
           this.echartsType14 = 27;
          break;
           case 28:
          this.echartsType14 = 28;
          break;
             case 29:
          this.echartsType15 = 29;
          break;
             case 30:
          this.echartsType15 = 30;
          break;
              case 31:
          this.echartsType16 = 31;
          break;
              case 32:
          this.echartsType16 = 32;
          break;
      }
    },
    // 申请量/授权量切换
    applybtn(val) {
      switch (val) {
        case 1:
          this.numType1 = 1;
          break;
        case 3:
          this.numType2 = 3;
          break;
        case 5:
          this.numType3 = 5;
          break;
        case 7:
          this.numType4 = 7;
          break;
        case 9:
          this.numType5 = 9;
          break;
        case 13:
          this.numType6 = 13;
          break;
      }
    },
    agreebtn(val) {
      switch (val) {
        case 2:
          this.numType1 = 2;
          break;
        case 4:
          this.numType2 = 4;
          break;
        case 6:
          this.numType3 = 6;
          break;
        case 8:
          this.numType4 = 8;
          break;
        case 10:
          this.numType5 = 10;
          break;
        case 14:
          this.numType6 = 14;
          break;
      }
    },
    yxfmbtn(val) {
      switch (val) {
        case 11:
          this.numType5 = 11;
          break;
        case 15:
          this.numType6 = 15;
          break;
      }
    },
    wxzlbtn(val) {
      switch (val) {
        case 12:
          this.numType5 = 12;
          break;
        case 16:
          this.numType6 = 16;
          break;
      }
    },
    // 封装转换年季度时间格式的方法
    switchTime(value) {
      var e, y;
      if (value.toString().split("").length == 4) {
        value = value + "年";
      } else if (value.toString().split("").length == 5) {
        e = value.slice(-1);
        if (e == "1") {
          e = "第一季度";
        } else if (e == "2") {
          e = "第二季度";
        } else if (e == "3") {
          e = "第三季度";
        } else if (e == "4") {
          e = "第四季度";
        }
        y = value.slice(0, 4);
        value = y + "年" + e;
      }
      return value;
    },
    // 专利分析统计
    zlAnalyCount() {
      this.$GET("/patent/alyInfo", {
        cnty: this.region,
        time: this.timevalueS,
        // time:"2018"
      }).then((res) => {
        this.dataSummary = res.data;
      });
    },
    // 获取国内专利分析的方法
    domasticzlDatas() {
      this.$GET("/patent/domesticPtAly", {
        cnty: this.region,
        time: this.timevalueS,
      }).then((res) => {
        // 国内专利趋势
        this.$store.commit("getzldatas", res.data);
        if (res.data.trendApList.length == 0) {
          this.havedata1 = false;
        } else {
          this.havedata1 = true;
          this.trendApListzl = res.data.trendApList;
          this.trendApListzl.forEach((ele) => {
            ele.name = this.switchTime(ele.name);
          });
        }

        Pantent.domesticzltrend();
        // 专利类型构成
        if (res.data.apTyCount.length == 0) {
          this.havedata2 = false;
        } else {
          this.havedata2 = true;
          this.apTyCountzl = res.data.apTyCount;
        }
          // 发明有效专利申请人分布
        if (res.data.apValidInv.length == 0) {
          this.havedata8 = false;
        } else {
          this.havedata8 = true;
          this.apValidzl = res.data.apValidInv;
        }

            // 实用新型有效专利申请人分布
        if (res.data.utilityValidInv.length == 0) {
          this.havedata25 = false;
        } else {
          this.havedata25 = true;
          this.utilityValidInvzl = res.data.utilityValidInv;
        }

            // 外观有效专利申请人分布
        if (res.data.designValidInv.length == 0) {
          this.havedata26 = false;
        } else {
          this.havedata26 = true;
          this.designValidInvzl = res.data.designValidInv;
        }

        if (res.data.apTyAuthCount.length == 0) {
          this.havedata3 = false;
        } else {
          this.havedata3 = true;
          this.apTyAuthCountzl = res.data.apTyAuthCount;
        }
        Pantent.zlType1();
        Pantent.zlType2();
        Pantent.applyMakeup1();
        Pantent.applyMakeup2();
        Pantent.ipcTecnicType1();
        Pantent.ipcTecnicType2();
        Pantent.rightIntener1();
        Pantent.rightIntener2();
         Pantent.rightIntener3();
        // 申请人构成及趋势
        // // 时间
        if (res.data.apTyTrendCount.length == 0) {
          this.havedata4 = false;
        } else {
          this.havedata4 = true;
        }
        if (res.data.apTyAuthTrendCount.length == 0) {
          this.havedata5 = false;
        } else {
          this.havedata5 = true;
        }
        this.timeRange = res.data.time;
        // IPC技术分类Top10
        if (res.data.ipcCount.length == 0) {
          this.havedata6 = false;
        } else {
          this.havedata6 = true;
          this.ipcCount = res.data.ipcCount;
        }
        if (res.data.ipcAuthCount.length == 0) {
          this.havedata7 = false;
        } else {
          this.havedata7 = true;
          this.ipcAuthCount = res.data.ipcAuthCount;
        }
        // 有效专利权利人分布
        if (res.data.apTyValidInvCount.length == 0) {
          this.havedata8 = false;
        } else {
          this.havedata8 = true;
        }
        if (res.data.apTyAuthValidInvCount.length == 0) {
          this.havedata9 = false;
        } else {
          this.havedata9 = true;
        }
      });
    },
    // 获取国内专利分析榜单
    gettopzl() {
      this.$GET("/patent/ptTopList", {
        cnty: this.region,
        time: this.timevalueS,
      }).then((res) => {
        this.$store.commit("getzlTop", res.data);
        if (res.data.appTop10.length == 0) {
          this.havedata10 = false;
        } else {
          this.havedata10 = true;
          this.appTop10 = res.data.appTop10;
          this.appTop50 = res.data.appTop50;
        }
        if (res.data.authTop10.length == 0) {
          this.havedata11 = false;
        } else {
          this.havedata11 = true;
          this.authTop10 = res.data.authTop10;
          this.authTop50 = res.data.authTop50;
        }
        if (res.data.validTop10.length == 0) {
          this.havedata12 = false;
        } else {
          this.havedata12 = true;
          this.validTop10 = res.data.validTop10;
          this.validTop50 = res.data.validTop50;
        }
        if (res.data.notValidTop10.length == 0) {
          this.havedata13 = false;
        } else {
          this.havedata13 = true;
          this.notValidTop10 = res.data.notValidTop10;
          this.notValidTop50 = res.data.notValidTop50;
        }

          if (res.data.zyTrend.length == 0) {
          this.havedata22 = false;
        } else {
          this.havedata22 = true;
          this.zyTrend = res.data.zyTrend;
          this.zyTrend.forEach((ele) => {
            ele.time = this.switchTime(ele.time);
          });
          
        }

          if (res.data.zrTrend.length == 0) {
          this.havedata23 = false;
        } else {
          this.havedata23 = true;
          this.zrTrend = res.data.zrTrend;
            this.zrTrend.forEach((ele) => {
            ele.time = this.switchTime(ele.time);
          });
        }

          if (res.data.xkTrend.length == 0) {
          this.havedata24 = false;
        } else {
          this.havedata24 = true;
          this.xkTrend = res.data.xkTrend;
          this.xkTrend.forEach((ele) => {
            ele.time = this.switchTime(ele.time);
          });
        }

        Pantent.domesticzltop1();
        Pantent.domesticzltop2();
        Pantent.domesticzltop3();
        Pantent.domesticzltop4();
        Pantent.patentdj();
        Pantent.patentxuke();
        Pantent.patentzhuanrang();
      });
    },
    // 获取PCt专利分析数据
    getPCTzl() {
      this.$GET("/patent/ptPctAly", {
        cnty: this.region,
        time: this.timevalueS,
      }).then((res) => {
        this.$store.commit("pctPublic", res.data);
        if (res.data.pctTrendCount.length == 0) {
          this.havedata14 = false;
        } else {
          this.havedata14 = true;
          this.pctTrendCount = res.data.pctTrendCount;
          this.pctTrendCount.forEach((ele) => {
            ele.name = this.switchTime(ele.name);
          });
        }

        Pantent.pctzltrend();
        if (res.data.pctIpcTop10.length == 0) {
          this.havedata15 = false;
        } else {
          this.havedata15 = true;
          this.pctIpcTop10 = res.data.pctIpcTop10;
        }

        Pantent.ipcttype();
        if (res.data.pctTop10Count.length == 0) {
          this.havedata16 = false;
        } else {
          this.havedata16 = true;
          this.pctTop10Count = res.data.pctTop10Count;
          this.pctTop50Count = res.data.pctTop50Count;
        }

        Pantent.pctPublictop10();
      });
    },
    // 获取专利状态分析数据
    getzlStatus() {
      this.$GET("/patent/ptLawAly", {
        cnty: this.region,
        time: this.timevalueS,
      }).then((res) => {
        this.$store.commit("zlStatusAnaly", res.data);
        if (res.data.ptLawCount.length == 0) {
          this.havedata17 = false;
        } else {
          this.havedata17 = true;
          this.ptLawCount = res.data.ptLawCount;
        }
        Pantent.zlstatus();
      });
    },
    // 获取区域专利比较数据
    getregionzl() {
      this.$GET("/patent/areaCmpAly", {
        cnty: this.region,
        time: this.timevalueS,
      }).then((res) => {
        this.$store.commit("zlRegionCompare", res.data);
        if (res.data.areaApplyTrendCount.length == 0) {
          this.havedata18 = false;
        } else {
          this.havedata18 = true;
        }
        if (res.data.areaAuthTrendCount.length == 0) {
          this.havedata19 = false;
        } else {
          this.havedata19 = true;
        }
        if (res.data.areaPctTrendCount.length == 0) {
          this.havedata20 = false;
        } else {
          this.havedata20 = true;
        }
        if (res.data.areaValidTrendCount.length == 0) {
          this.havedata21 = false;
        } else {
          this.havedata21 = true;
        }
        Pantent.regionzlDCompare1();
        Pantent.regionzlDCompare2();
        Pantent.regionzlDCompare3();
        Pantent.regionzlDCompare4();
      });
    },
    // 查看更多top50
    seeMore50(value) {
      this.seeMore = true;
      switch (value) {
        case 101:
          this.tableData50 = this.appTop50;
          this.label50 = "专利申请量";
          break;
        case 102:
          this.tableData50 = this.authTop50;
          this.label50 = "专利授权量";
          break;
        case 103:
          this.tableData50 = this.validTop50;
          this.label50 = "有效发明量(累计)";
          break;
        case 104:
          this.tableData50 = this.notValidTop50;
          this.label50 = "无效专利量";
          break;
        case 105:
          this.tableData50 = this.pctTop50Count;
          this.label50 = "PCT公开量";
          break;
      }
    },
    // 导出更多
    daochu(value) {
      let aLink = document.createElement("a");
      aLink.href =
        this.$url +
        "/applicant/alyTopExport?token=" +
        localStorage.getItem("token") +
        "&uid=" +
        localStorage.getItem("uid") +
        "&cnty=" +
        this.region +
        "&time=" +
        this.timevalueS +
        "&key=" +
        value;
      aLink.click();
    },
    // 滚动条监听事件
    scrollHandle() {
      let scrollObj = document.querySelector(".contentBack4"); // 获取滚动区域
      let clientHeight = scrollObj.clientHeight; // 容器的高度
      let scrollTop = scrollObj.scrollTop; // 已滚动的距离

      let echartsObj1 = document.querySelector("#ipcjstop10");
      let echartsHeight1 = echartsObj1.offsetTop; //当前表格离顶部的高度
      let echartsObj2 = document.querySelector("#yxfmwcfb");
      let echartsHeight2 = echartsObj2.offsetTop;
      let echartsObj3 = document.querySelector("#pctzlqs");
      let echartsHeight3 = echartsObj3.offsetTop;
      let echartsObj4 = document.querySelector("#zlztfx");
      let echartsHeight4 = echartsObj4.offsetTop;
      if (
        clientHeight + scrollTop > echartsHeight1 - 100 &&
        this.firstscroll1
      ) {
        this.firstscroll1 = false;
        this.gettopzl();
      }
      if (
        clientHeight + scrollTop > echartsHeight2 - 100 &&
        this.firstscroll2
      ) {
        this.firstscroll2 = false;
        this.getPCTzl();
      }
      if (
        clientHeight + scrollTop > echartsHeight3 - 100 &&
        this.firstscroll3
      ) {
        this.firstscroll3 = false;
        this.getzlStatus();
      }
      if (
        clientHeight + scrollTop > echartsHeight4 - 100 &&
        this.firstscroll4
      ) {
        this.firstscroll4 = false;
        this.getregionzl();
      }
    },
  },
  mounted() {
    let dom = document.getElementsByClassName("contentBack4")[0];
    if (dom) {
      dom.addEventListener("scroll", this.scrollHandle, true);
    }
    //   获取当前年
    let year = new Date().getFullYear();
    this.optionsTime[0].value = year;
    this.optionsTime[0].label = year + "年";
    this.optionsTime[1].value = year - 1;
    this.optionsTime[1].label = year - 1 + "年";

    // 获取当前时间全部
    // let year1 = new Date().getFullYear();
    // console.log('---------year',year1)
    // // 获取当前季度
    // let season = Math.floor((new Date().getMonth() + 3) / 3);
    let arr = [];
    this.$set(arr, 0, year);
    this.$set(arr, 1, "");
    this.timevalue = arr;
    // console.log("this.timevalue ", this.timevalue);
    this.timevalueS = this.timevalue.join("");
    // console.log("this.timevalueS ", this.timevalueS);

    // 获取当前季度
    // let season = Math.floor((new Date().getMonth() + 3) / 3);
    // var arr = [];
    // this.$set(arr, 0, year);
    // this.$set(arr, 1, season.toString());
    // this.timevalue = arr;
    // this.timevalueS = this.timevalue.join("");
    // 获取地区权限
    let DataPermission = JSON.parse(localStorage.getItem("DataPermission"));
    // console.log('DataPermission',DataPermission)
    DataPermission.forEach((element, index) => {
      DataPermission[index]["value"] = element.name;
      DataPermission[index]["label"] = element.name;
    });
    this.optionsRegion = DataPermission;
    // 统计
    this.zlAnalyCount();
    // 国内专利
    this.region = "全部区域";
    this.domasticzlDatas();
  },
  watch: {},
  destroyed() {
    window.removeEventListener("scroll", this.scrollHandle);
  },
};
</script>
<style>
.other-tips {
  float: right;
  font-size: 14px;
}
.data-tips {
     font-size: 16px;
    color: #1773d5;
    font-weight: bold;
   margin-top: 14px;
   margin-left: 14px;
 
}
.zl2new {
  height: 1800px;
}
.apValidzl {
  font-size: 16px;
  text-align: center;
  margin: 14px;
  font-weight: 700;
}
.apValidata {
  height: 380px;
}
.echarts-title {
  margin-left: 6%;
}
</style>